<template>
  <div class="lang-switch" @click="$i18n.toggleLocale()">
    <span :class="{ active: $i18n.currentLocale() === 'zh-CN' }">{{ $i18n.t('langSwitch.zhCN') }}</span>
    <span class="divider">/</span>
    <span :class="{ active: $i18n.currentLocale() === 'zh-TW' }">{{ $i18n.t('langSwitch.zhTW') }}</span>
  </div>
</template>

<script setup>
</script>

<style scoped>
.lang-switch {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  font-size: 1.2rem;
  color: #64748b;
  transition: color 0.3s;
}

.lang-switch:hover {
  color: #4779B5;
}

.lang-switch span {
  transition: all 0.3s;
}

.lang-switch span.active {
  color: #4779B5;
  font-weight: 600;
}

.lang-switch .divider {
  color: #4a5568;
}
</style>
